// src/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const startYear = 2025;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <style>{`
        .footer {
          margin-top: 4rem;
          background: #ffffff;                 /* top (logo) section stays white */
          color: #374151;                      /* Gray-700 for the white section */
          border-top: 1px solid #e5e7eb;       /* subtle divider from page content */
        }
        .footer .wrap {
          max-width: 80rem;                    /* ~1280px */
          margin: 0 auto;
          padding: 2rem 1rem 0;                /* no bottom padding here (black bar handles it) */
        }
        /* Logo row (white background) */
        .footer .logo {
          display: flex;
          justify-content: center;
          margin-bottom: 0;                    /* black bar follows immediately */
        }
        .footer .logo img {
          height: 128px;                       /* double-size logo */
          width: auto;
          object-fit: contain;
        }
        @media (min-width: 768px) {
          .footer .logo img { height: 140px; } /* slight bump on md+ */
        }

        /* Black bar (everything below the logo) */
        .footer .bar {
          background: #000000;                 /* sleek black */
          color: #f3f4f6;                      /* near-white text */
          margin-top: 1rem;                    /* small offset below logo */
          padding: 1.25rem 1rem 2.25rem;       /* comfy bottom spacing */
        }
        .footer .links {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 2rem;                           /* generous spacing between items */
          flex-wrap: wrap;
          margin-bottom: 1rem;
          font-size: 1.0625rem;                /* between base and lg */
        }
        .footer a {
          color: inherit;                      /* no purple/blue */
          text-decoration: none;
        }
        .footer a:hover {
          text-decoration: underline;
          text-underline-offset: 4px;
        }
        .footer a:visited { color: inherit; }  /* keep colors consistent */
        .footer .pipe {
          opacity: 0.45;
          user-select: none;
        }
        .footer .bottom {
          text-align: center;
          color: #d1d5db;                      /* Gray-300 on black */
          font-size: 0.95rem;
          line-height: 1.5;
        }
      `}</style>

      {/* White section: Logo only */}
      <div className="wrap">
        <div className="logo">
          <img src="/logo/playswithguru-logo.png" alt="PlaysWithGuru Logo" />
        </div>
      </div>

      {/* Black section: links + copyright */}
      <div className="bar">
        <nav className="links" aria-label="Footer">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="pipe">|</span>
          <Link to="/terms-of-service">Terms of Service</Link>
          <span className="pipe">|</span>
          <Link to="/contact">Contact Us</Link>
        </nav>

        <div className="bottom">
          <div>
            © {startYear}{currentYear > startYear ? `–${currentYear}` : ""} PlaysWithGuru — a PLYWIG company. All rights reserved.
          </div>
          <div>Predictive analytics for sports &amp; markets.</div>
        </div>
      </div>
    </footer>
  );
}
